"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const muiTypography = {
    styleOverrides: {
        h1: {},
        h2: {},
        h3: {},
        h4: {},
        h5: {},
        h6: {},
        subtitle1: {},
        subtitle2: {},
        body1: {},
        body2: {},
    },
};
exports.default = muiTypography;
//# sourceMappingURL=muiTypography.js.map